import type { ReactNode } from "react";

type FieldGroupProps = {
  label: string;
  description?: string;
  required?: boolean;
  error?: string;
  children: ReactNode;
};

/**
 * Wraps a form control with a custom label + description (sublabel) above and an
 * optional error message below. Keeps the description between the label and the
 * field, which is not achievable via the Input/TextArea `hint` prop alone.
 */
export function FieldGroup({ label, description, required, error, children }: FieldGroupProps) {
  return (
    <div className="flex flex-col">
      <p className="text-sm font-bold text-[#181D27] mb-0.5">
        {label}
        {required && <span className="text-brand-secondary ml-0.5">*</span>}
      </p>
      {description ? <p className="text-xs text-tertiary mb-3">{description}</p> : <div className="mb-1.5" />}
      {children}
      {error && <p className="text-sm text-error-primary mt-1.5">{error}</p>}
    </div>
  );
}
